"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeCustomersApi = activeCustomersApi;
exports.addRechargeAuditConfig = addRechargeAuditConfig;
exports.asyncExportRecordApi = asyncExportRecordApi;
exports.asyncExportRecordDetailApi = asyncExportRecordDetailApi;
exports.auditIntegralLogApi = auditIntegralLogApi;
exports.deleteIntegralLogBatchApi = deleteIntegralLogBatchApi;
exports.exportRecordApi = exportRecordApi;
exports.exportRecordDetailApi = exportRecordDetailApi;
exports.getExportTaskListApi = getExportTaskListApi;
exports.getExportTaskStatusApi = getExportTaskStatusApi;
exports.getRechargeAuditConfig = getRechargeAuditConfig;
exports.getSummaryApi = getSummaryApi;
exports.infoApi = infoApi;
exports.listApi = listApi;
exports.updateBasicInfoApi = updateBasicInfoApi;
exports.updateProjectInfoApi = updateProjectInfoApi;
exports.updateRechargeAuditConfig = updateRechargeAuditConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 客户员工，发卡类型，列表
 */
function listApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/list",
    method: 'GET',
    params: params
  });
}
/**
 * 获取客户
 */
function activeCustomersApi() {
  return (0, _request.default)({
    url: "/admin/customers/active-customers",
    method: 'GET'
  });
}

/**
 * 详情
 */
function infoApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/info",
    method: 'GET',
    params: params
  }).then(function (response) {
    console.log('详情API返回原始数据:', response);

    // 处理新的返回格式，确保返回正确的数据结构
    if (response && response.data) {
      return response;
    } else {
      return response; // 兼容旧格式
    }
  });
}

/**
 * 更新项目编号和公司信息
 */
function updateProjectInfoApi(data) {
  console.log('API请求数据:', JSON.stringify(data));

  // 确保公司ID是个数字
  var processedData = _objectSpread({}, data);
  if (processedData.companyId && !isNaN(processedData.companyId)) {
    processedData.companyId = Number(processedData.companyId);
  }

  // 确保销售价是数字
  if (processedData.salesPrice && !isNaN(processedData.salesPrice)) {
    processedData.salesPrice = Number(processedData.salesPrice);
  }
  return (0, _request.default)({
    url: "/admin/customer/integral-log/update",
    method: 'POST',
    data: processedData
  });
}

/**
 * 更新项目基础信息（项目编号、公司、销售价）
 */
function updateBasicInfoApi(data) {
  console.log('更新项目基础信息API请求数据:', JSON.stringify(data));

  // 确保销售价是数字
  var processedData = _objectSpread({}, data);
  if (processedData.companyId !== '' && processedData.companyId !== undefined && processedData.companyId !== null && !isNaN(processedData.companyId)) {
    processedData.companyId = Number(processedData.companyId);
  }
  if (processedData.salesPrice && !isNaN(processedData.salesPrice)) {
    processedData.salesPrice = Number(processedData.salesPrice);
  }
  return (0, _request.default)({
    url: "/admin/customer/integral-log/update-basic",
    method: 'POST',
    data: processedData
  });
}

/**
 * 导出操作记录
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
function exportRecordApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/export",
    method: 'GET',
    params: params
  });
}

/**
 * 获取统计数据
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
function getSummaryApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/summary",
    method: 'GET',
    params: params
  });
}

/**
 * 导出操作明细
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
function exportRecordDetailApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/export-detail",
    method: 'GET',
    params: params
  });
}

/**
 * 创建异步导出操作记录任务
 * @param {Object} params - 查询参数
 */
function asyncExportRecordApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/async/export",
    method: 'GET',
    params: params
  });
}

/**
 * 创建异步导出操作明细任务
 * @param {Object} params - 查询参数
 */
function asyncExportRecordDetailApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/async/export-detail",
    method: 'GET',
    params: params
  });
}

/**
 * 查询导出任务状态
 * @param {Number} taskId - 任务ID
 */
function getExportTaskStatusApi(taskId) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/async/task/".concat(taskId),
    method: 'GET'
  });
}

/**
 * 获取导出任务列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.taskType - 任务类型（CUSTOMER_INTEGRAL_LOG_EXPORT 或 CUSTOMER_INTEGRAL_LOG_DETAIL_EXPORT）
 */
function getExportTaskListApi(params) {
  return (0, _request.default)({
    url: '/admin/download/task/list',
    method: 'POST',
    data: params
  });
}

/**
 * 审核福豆发放批次
 */
function auditIntegralLogApi(data) {
  return (0, _request.default)({
    url: '/admin/customer/integral-log/audit',
    method: 'POST',
    data: data
  });
}

/**
 * 删除福豆发放批次
 */
function deleteIntegralLogBatchApi(id) {
  return (0, _request.default)({
    url: '/admin/customer/integral-log/delete',
    method: 'DELETE',
    params: {
      id: id
    }
  });
}

/**
 * 查询充值审核配置
 */
function getRechargeAuditConfig() {
  return (0, _request.default)({
    url: '/admin/recharge-audit-config',
    method: 'GET',
    preserveNullData: true
  });
}

/**
 * 新增充值审核配置
 */
function addRechargeAuditConfig(data) {
  return (0, _request.default)({
    url: '/admin/recharge-audit-config',
    method: 'POST',
    data: data
  });
}

/**
 * 修改充值审核配置
 */
function updateRechargeAuditConfig(data) {
  return (0, _request.default)({
    url: '/admin/recharge-audit-config',
    method: 'PUT',
    data: data
  });
}